import React, { useState, useEffect, useRef } from 'react';
import Loader from 'react-loader-spinner';
import DropIn from 'braintree-web-drop-in-react';
import axios from 'axios';

const Payment = ({ customerId, Loader, state, onSuccessTap, onChangeOrderRefId, changeCouponCodeDetails,conditionAmount }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_KEY;
  const [loading, setLoading] = useState(false);
  const [checkTermAndContition, setcheckTermAndContition] = useState('');
  const [checkTermAndContitionAlert, setcheckTermAndContitionAlert] = useState(false);
  const [agreeTermsError, setagreeTermsError] = useState(false);

  const [apiMessage, setApiMessage] = useState('');
  const [apiStatus, setApiStatusCode] = useState('');
  const [apiCalled, setApiCalled] = useState(false);
  const [clientToken, setClientToken] = useState('');
  const instanceRef = useRef(null);
  const [checkoutLoader, setCheckoutLoader] = useState(false);
  const [couponCode, setCounponCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [voucherCode, setVoucherCode] = useState(true);
  const [amount, setAmount] = useState(state.amount);
  const [code, setCode] = useState('')



  useEffect(() => {
    //  if(state.amount !== '0.00') {
      fetchToken();
    //  }
    
   
    const releventDiv = document.getElementById('Payment');
    releventDiv.scrollIntoView({ behavior: "smooth" });


  }, []);

  const fetchToken = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}payments/get-client-token`,
        {
          headers: {
            'api-token': 'qazxsw321@',
            'Content-Type': 'application/json',
          },
        }
      );
      const clientToken = response.data.data.clientToken;

      setClientToken(clientToken);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching client token:', error);
      setLoading(false);
    }
  };

  const handlecheckTermAndContition = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setcheckTermAndContition(true);
      setcheckTermAndContitionAlert(false);
      setagreeTermsError(false);
    } else {
      setcheckTermAndContition(false)
      setcheckTermAndContitionAlert(true);
      setagreeTermsError(true);
    }
  }

  const handlesetCounponCode = (Typedvalue) => {

    setCounponCode(Typedvalue)
    if (Typedvalue.length === 0) {
      changeCouponCodeDetails('')
      setErrorMessage();
      setSuccessMessage()
    }
  }

  const applyCoupon = async (e) => {
    changeCouponCodeDetails('')
    try {
      const postData = {
        nbn_voucher_code: couponCode,
        visp_qualification_id: state.vispID,
        payable_amount: state.amount
      };

      const response = await axios.post(`${apiUrl}check_nbn_voucher_code_validity`, postData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.status === 200) {
        console.error('Error:', response);
        throw new Error(response.data.data.message);
      } else {
        setVoucherCode(response.data.data.voucher_name);
        setCode(couponCode)
        const voucherDetails = {
          'voucher_name': response.data.data.voucher_name,
          'new_payable_amount': response.data.data.new_payable_amount,
          'plan_amount_after_discount': response.data.data.plan_amount_after_discount,
          'voucher_amount': response.data.data.voucher_amount,
          'nbn_voucher_discounted_amount': response.data.data.nbn_voucher_discounted_amount,
          "plan_gst_inclusive_sale_amount": response.data.data.plan_gst_inclusive_sale_amount,
          "nbn_credit_added":response.data.data.nbn_credit_added,
        }


        if (response.data.data.new_payable_amount < 1) {
          setVoucherCode(null); // Hide payment gateway
        } else {
          setVoucherCode(true);
        }
        changeCouponCodeDetails(voucherDetails)
        setErrorMessage();
        setSuccessMessage(response.data.message)

      }

    } catch (error) {
      setVoucherCode(true);
      setErrorMessage(error.response.data.message);
      setSuccessMessage('')
    }
  }

  const buy = async (e) => {
    e.preventDefault();

    if (!checkTermAndContition) {
      setcheckTermAndContition(false)
      setcheckTermAndContitionAlert(true);
      setagreeTermsError(true);
      return; // Stop the function execution
    }

    try {
      let nonce = 'False';

      if (voucherCode&&conditionAmount>="1") {
        const { nonce: generatedNonce } = await instanceRef.current.requestPaymentMethod();
        nonce = generatedNonce;
      }
      const requestData = {
        nonce: nonce,
        visp_qualification_id: state.vispID,
        nbn_voucher_code: code,
        shipping_charge: state.shipping_charge
      };


      setCheckoutLoader(true);

      const response = await axios.post(
        `${apiUrl}nbn_customer_purchase_payment`,
        requestData,
        {
          headers: {
            'Content-Type': 'application/json',
            'App-type': 'NBNTSWEB'
          },
        }
      );


      if (response.status === 200) {
        setApiCalled(true);
        const data = response.data;

        setApiMessage([data.message]);
        setApiStatusCode(data.status);

        onChangeOrderRefId(data.data.ordRefID);
        onSuccessTap();
      } else {
        setApiCalled(true);
        throw new Error('Failed to make the API call');
      }
    } catch (error) {

      setApiCalled(true);
      setApiStatusCode(false);
      setApiMessage(error.response ? error.response.data.message : error.message);
    } finally {
      setCheckoutLoader(false);
    }
  };

  return (
    <div id="Payment" className="tabcontent">
      <div>
        {loading ? (
          <div>
            <Loader
              type="Puff"
              color="#00BFFF"
              height={100}
              width={100}
              timeout={4000}
            />
          </div>
        ) : (
          <div>
            {!clientToken ? (
              <div>
                <Loader
                  type="Puff"
                  color="#00BFFF"
                  height={100}
                  width={100}
                  timeout={3000}
                />
              </div>
            ) : (
              <div>
                <div className="form-field col-lg-12">
                  <label className="label" htmlFor="mobile">
                    Special promo code or did a friend refer you?
                  </label>
                  <div className="input-group">
                    <input type="text" className="input form-control" onChange={e => handlesetCounponCode(e.target.value)} name="coupon" /> <br></br> <a className='btn btn-success coupon-btn' onClick={applyCoupon}>Apply </a>
                  </div>
                  {errorMessage && (
                    <p style={{ color: 'red', textAlign: 'left' }}>
                      <span style={{ marginRight: '5px' }} role="img" aria-label="Error">&#9888;</span>
                      {errorMessage}
                    </p>
                  )}
                  {successMessage && (
                    <p style={{ color: 'green', textAlign: 'left' }}>
                      <span role="img" aria-label="Success">&#10004;</span> {successMessage}
                    </p>
                  )}
                  <p style={{ textAlign: 'left', textDecoration: 'underline', marginTop: '10px', display: 'none' }}>Have an agent code?</p>

                </div>
                
                    {voucherCode && conditionAmount > "1" && (
                      <DropIn
                        options={{
                          authorization: clientToken,
                        }}
                        onInstance={(instance) => (instanceRef.current = instance)}
                      />
                    )}

                <br />
                <p style={{ textAlign: 'left' }}>Terms and conditions:</p>
                {/* <label className="check-box" style={checkTermAndContitionAlert ? { color: '#777' } : {}}>
                  I have read and accept the <span style={checkTermAndContition ? { color: '#d30058' } : { color: 'red' }}><a target="_blank" href='https://www.telsim.com.au/website-terms-conditions/' style={checkTermAndContition ? { color: '#d30058', textDecoration: 'none' } : { color: '#d30058', textDecoration: 'none' }} >Terms & Conditions</a></span>, the Acceptable Use Policy,
                  the <span style={checkTermAndContition ? { color: '#d30058', textDecoration: 'none' } : { color: '#d30058', textDecoration: 'none' }} ><a target="_blank" href='https://www.telsim.com.au/website-privacy-policy/' style={checkTermAndContition ? { color: '#d30058', textDecoration: 'none' } : { color: '#d30058', textDecoration: 'none' }}>Privacy Policy</a></span> and <span style={checkTermAndContition ? { color: '#d30058', textDecoration: 'none' } : { color: '#d30058', textDecoration: 'none' }} ><a target="_blank" href='https://www.telsim.com.au/contact-us/' style={checkTermAndContition ? { color: '#d30058', textDecoration: 'none' } : { color: '#d30058', textDecoration: 'none' }}>Customer Service Guarantee Waiver</a></span> for my Telsim service.
                  <input type="checkbox" required="" id="agreeTerms" title="Please check and agree to the terms and conditions" value={checkTermAndContition} onChange={handlecheckTermAndContition} />
                  <span className="tick"></span>
                </label> */}
                <label className="check-box" style={checkTermAndContitionAlert ? { color: '#777' } : {}}>
                  I have read and accept the
                  <span style={checkTermAndContition ? { color: '#d30058' } : { color: 'red' }}>
                    <a target="_blank" href='https://www.telsim.com.au/website-terms-conditions/' style={checkTermAndContition ? { color: '#d30058', textDecoration: 'none' } : { color: '#d30058', textDecoration: 'none' }}>
                      Terms & Conditions
                    </a>
                  </span>, the Acceptable Use Policy,
                  the  <span></span>
                  <span style={checkTermAndContition ? { color: '#d30058', textDecoration: 'none' } : { color: '#d30058', textDecoration: 'none' }}>
                    <a target="_blank" href='https://www.telsim.com.au/website-privacy-policy/' style={checkTermAndContition ? { color: '#d30058', textDecoration: 'none' } : { color: '#d30058', textDecoration: 'none' }}>
                      Privacy Policy
                    </a>
                  </span> for my Telsim service.
                  <input type="checkbox" required="" id="agreeTerms" title="Please check and agree to the terms and conditions" value={checkTermAndContition} onChange={handlecheckTermAndContition} />
                  <span className="tick"></span>
                </label>

                <br />
                <div className="row">
                  <div className="form-field col-lg-12">
                    <input className="payment-submit-btn" type="submit" value="CONTINUE" disabled={errorMessage} onClick={buy} />
                  </div>
                </div>
                <br></br>
                {apiCalled && (
                  <div>
                    {apiStatus === 200 ? (
                      <div className="alert alert-success">
                        <strong>Successfully Submitted!</strong> {apiMessage}
                      </div>
                    ) : (
                      <div className="alert alert-danger">
                        <strong>Submission Failed!</strong> {apiMessage}
                      </div>
                    )}
                  </div>
                )}
                {agreeTermsError === true && (
                  <>
                    <br />
                    <div className="alert alert-danger">
                      <strong>Please check and agree to the terms and conditions</strong>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        )}
      </div>
      <br></br>
      {checkoutLoader && (
        <div className="checkoutloader">
          <Loader
            type="Puff"
            color="#00BFFF"
          />
        </div>
      )}
    </div>
  );
};

export default Payment;
